import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BaseCheckbox,
  CheckboxIndicator,
  CheckboxLabel,
  IconAccountCircle,
  ChipContentWithIcon,
  Button,
  Link
} from 'cdk-radial';
import Footer from '../footer';
import FortellisTermsOverlay from './FortellisTermsOverlay';
import classes from './FortellisTermsDialog.module.css';
import BackgroundImage from '../BackgroundImage/BackgroundImage';
import { CdkLogo_blk } from '../CdkLogo/CdkLogo';
import CardDisplay from '../CardDisplay/CardDisplay';
import StepperContainer from '../stepper/StepperContainer';
import { Loading } from '../loader/Loading';
import { updateFortellisTerms } from '../../redux/connectedComponent/updateFortellisTerms/updateFortellisTerms.slice';
import ErrorSection from '../ErrorSection';

const AGREE_FORTELLIS_TERMS =
  'Before continuing, you need to agree Fortellis Terms and Conditions.';

const FortellisTermsDialog = () => {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [showDialogbox, setShowDialogBox] = useState(false);
  const state = useSelector(state => state);
  const [loadStepper, setLoadStepper] = useState(false);

  const {
    fortellisTermsAndConditionsData,
    fortellisTermsAndConditionsUpdatedDate,
    authenticationToken,
    decodedToken: { firstName } = {},
    userEmail,
  } = state.loginDetailsSlice;

  const {
    acceptedLatestFortellisTerms,
    updateLatestFortellisTermsSuccess,
    isUpdateLatestFortellisTermsPending
  } = state.updateFortellisTermsSlice;

  useEffect(() => {
    setLoadStepper(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateLatestFortellisTermsSuccess]);

  const setCheckboxHandler = event => setChecked(event.target.checked);

  const enableDialogBoxHandler = () =>
    setShowDialogBox(prevShowDialogboxState => !prevShowDialogboxState);

  const disableDialogHandler = () =>
    setShowDialogBox(prevShowDialogboxState => !prevShowDialogboxState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onContinueClickHandler = useCallback(() => {
    dispatch(
      updateFortellisTerms({ userEmail, accessToken: authenticationToken })
    );
  });

  if (isUpdateLatestFortellisTermsPending) {
    return <Loading active={true} label={''} />;
  }

  if (loadStepper && acceptedLatestFortellisTerms) {
    return <StepperContainer />;
  }

  return (
    <Fragment>
      <BackgroundImage>
        <CardDisplay>
          <CdkLogo_blk />
          <div className={classes.chip}>
            <ChipContentWithIcon
              disableFocus={false}
              icon={
                <IconAccountCircle
                  focusable={false}
                  height={24}
                  role="presentation"
                  viewBox="0 0 24 24"
                  width={24}
                />
              }
              label={userEmail}
              value={null}
            ></ChipContentWithIcon>
          </div>
          <div className={classes.welcome}>Welcome {firstName}</div>
          {state.errorInUpdateLatestFortellisTerms && (
            <ErrorSection
              title={'Fortellis terms and conditions Acceptance failed'}
              subtitle={'Please try again'}
            />
          )}
          <div className={classes['dealership-msg']}>
            {AGREE_FORTELLIS_TERMS}
          </div>
          <div className={classes.checkbox}>
            <BaseCheckbox
              checked={checked}
              onChange={setCheckboxHandler}
              renderIndicator={() => <CheckboxIndicator />}
              renderLabel={() => <CheckboxLabel />}
            />
            <p className={classes['fortellis-terms']}>
              I accept the{' '}
              <Link
                isInline
                text="Fortellis Terms and Conditions"
                onClick={enableDialogBoxHandler}
              />
            </p>
          </div>
          <div className={classes['continue-button-container']}>
            <Button
              text="Continue"
              primary
              raised
              onClick={onContinueClickHandler}
            />
          </div>
        </CardDisplay>
        <Footer />
      </BackgroundImage>
      {(showDialogbox && (
        <FortellisTermsOverlay
          isOpen={showDialogbox}
          isClose={disableDialogHandler}
          fortellisTermsAndConditionsData={fortellisTermsAndConditionsData}
          fortellisTermsAndConditionsUpdatedDate={
            fortellisTermsAndConditionsUpdatedDate
          }
        />
      )) ||
        null}
    </Fragment>
  );
};

export default FortellisTermsDialog;